<template>
    <div>
        <div class="row py-2 mx-5">
            <div class="col-12">
                <form @submit.prevent="validateTracking()">
                    <div class="row">
                        <div class="col-9">
                            <h6 class="heading-small text-muted">กรอกหมายเลขพัสดุ</h6>
                            <input
                                ref="searchTracking"
                                type="text"
                                class="form-control m-1"
                                :class="{'has-error':isError.errorMsg}"
                                :placeholder="isPlaceholder"
                                @change="clearError($event)"
                                v-on:keyup="clearError($event)"
                                v-model="isTracking.trackingCode"
                            />
                            </div>
                        <div class="col-3 d-flex align-items-end justify-content-center">
                            <b-button 
                                type="submit"
                                block
                                variant="primary" 
                                class="m-1"
                                :disabled="isTracking.trackingCode.length < 11 || isLoading"
                            >
                                <i class="fas fa-circle-notch fa-spin" v-if="isLoading"></i>
                                นำเข้า
                            </b-button>
                        </div>
                        <div class="col-12 text-center text-danger" v-if="isError.errorMsg">
                            {{isError.errorMsg}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <label floater>
                                น้ำหนัก {{ $THEME.unitKG ? '( กิโลกรัม )' : '( กรัม )' }} <small class="text-danger">*</small>
                            </label>
                            <input
                                step="0.01"
                                type="number"
                                placeholder="น้ำหนัก"
                                class="form-control"
                                ref="focusWeight"
                                :disabled="favoriteWeight"
                                @change="checkMaximum"
                                v-model="isTracking.parcel.weight"
                                @keyup="checkWeight()"
                                @blur="checkWeight()"
                                :onkeydown="$THEME.unitKG ? 'return event.keyCode !== 69 && event.keyCode !== 189' : 'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                                :class="{ 'is-invalid': $v.isTracking.parcel.weight.$error || validateWeight.checkWeight.status}"
                            />
                            <div
                                v-if="!$v.isTracking.parcel.weight.required"
                                class="invalid-feedback"
                            >
                                กรุณากรอกน้ำหนัก
                            </div>
                            <small 
                                v-if="validateWeight.checkWeight.status" 
                                class="text-danger"
                            >{{validateWeight.checkWeight.msg}} </small>
                        </div>
                        <div class="d-flex align-items-center pl-0">
                            <span @click="lockWeightParcel()">
                                <Icon 
                                    :icon="(favoriteWeight) ? 'mdi-lock' : 'mdi-lock-open-variant'" 
                                    class="cursor-pointer"
                                />
                            </span>
                        </div>
                        <div class="col">
                            <AutoBox
                                :listSize="listSize"
                                :size="isTracking.size"
                                :weight.sync="isTracking.parcel.weight"
                                :weightKG.sync="isTracking.parcel.weightKG" 
                                :width.sync="isTracking.parcel.width"
                                :length.sync="isTracking.parcel.length" 
                                :height.sync="isTracking.parcel.height" 
                                :keyBox.sync="isTracking.parcel.keyBox"
                                :favoriteDimension="isTracking.favoriteDimension"
                                courier_key="KRYDS" 
                            />
                        </div>
                        <div class="col">
                            <Dimension
                                ref="dimensionParcel"
                                :dimension="isTracking.parcel"
                                courierCode="KRYDS"
                                :favoriteDimension="isTracking.favoriteDimension"
                                @lockDimensionParcel="lockDimensionParcel"
                            />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import AutoBox from '@/components/AutoBox';
import { checkWeightRules } from "@/plugins/weightParcel.js"
import Dimension from '@/components/custom/pos/Dimension';
import setLocalStorage from '@/constants/LocalStorageManagement'
import { checkWeightMaximumByCourierCode } from "@/plugins/posHelper.js";

import {
  required
} from "vuelidate/lib/validators"

export default {
    name:"scanTrackingKerryDropoff",
    props:{
        isLoading: Boolean,
        isPlaceholder: String,
        isError: Object,
        isTracking: Object,
        courierCode: String,
        listSize: Object,
        shopId: [Number, String]
    },
    components:{
        AutoBox,
        Dimension
    },
    data(){
        return{
            validateWeight:{
                checkWeight:{
                    status:false,
                    msg:""
                }
            },
        }
    },
    validations: {
        isTracking:{
            parcel:{
                weight: { required },
            } 
        }
    },
    methods: {
        clearError( event ) {
            this.isError.errorMsg = false;

            if( this.isTracking.trackingCode.length > 5 ){
                this.$emit('checkTrackingRegx' , event)
            }
        },
        validateTracking(){
            //  if (this.isTracking.trackingCode)
            //     this.isTracking.trackingCode = this.isTracking.trackingCode.trim().split(' ')[0]

            if( this.isTracking.trackingCode.length < 11 || this.isLoading ){
                return false
            }

            this.$v.isTracking.$touch()
            this.$refs.dimensionParcel.$v.dimension.$touch();

            if( this.$v.isTracking.parcel.weight.$invalid ){
                this.$nextTick(() => this.$refs.focusWeight.focus())
                return false
            }

            if( this.$refs.dimensionParcel.$v.dimension.$invalid ){
                this.$nextTick(() => this.$refs.dimensionParcel.$refs.focusWidth.focus())
                return false
            }

            if( this.validateWeight.checkWeight.status || this.$refs.dimensionParcel.validateDimension.checkDimension.status ){
                return false
            }

            this.$emit('checkTracking')
        },
        checkMaximum(event){
            // this.isTracking.parcel.weight = checkWeightMaximumByCourierCode(event.target.value , this.courierCode)
        },
        checkWeight(){
            const { status , msg } = checkWeightRules( this.courierCode , this.isTracking.parcel.weight );
            this.validateWeight.checkWeight.status = status
            this.validateWeight.checkWeight.msg = msg
        },
        clearValidate(){
            this.$nextTick(() => { 
                this.$v.isTracking.$reset();
                this.$refs.dimensionParcel.$v.dimension.$reset();
                this.validateWeight.checkWeight.status = false
                this.$refs.dimensionParcel.validateDimension.checkDimension.status = false
            })
        },
        lockDimensionParcel(){
            let dimension = {
                width: this.isTracking.parcel.width,
                length: this.isTracking.parcel.length,
                height: this.isTracking.parcel.height,
                size: this.isTracking.size.boxSize
            }
            let checkDimension = this.getDimensionLocalStorage();
            let keyStorage = `${this.courierCode}_${this.shopId}`;
            
            if( checkDimension.status 
                && ( checkDimension.data.width > 0 
                    || checkDimension.data.length > 0 
                    || checkDimension.data.height > 0 
                ) 
            ){
                checkDimension.data.width = ""
                checkDimension.data.length = ""
                checkDimension.data.height = ""
                checkDimension.data.size = ""
                setLocalStorage.dimension().set( keyStorage , checkDimension.data );
                this.isTracking.favoriteDimension = false;
                return false;
            } 

            if(dimension.width > 0 || dimension.length > 0 || dimension.height > 0){
                if(checkDimension.status && checkDimension.data.weight){
                    dimension.weight = checkDimension.data.weight
                }
                setLocalStorage.dimension().set( keyStorage , dimension );
                this.isTracking.favoriteDimension = true;
            }
        },
        lockWeightParcel(){
            if(['shippop', 'quickexpress'].includes(this.$THEME.name)){
                let keyStorage = `${this.courierCode}_${this.shopId}`;
                let checkDimension = this.getDimensionLocalStorage();

                if( checkDimension.status && checkDimension.data.weight ){
                    checkDimension.data.weight = ""
                    setLocalStorage.dimension().set( keyStorage , checkDimension.data );
                    this.isTracking.favoriteWeight = false;
                    return false;
                } 

                if(this.isTracking.parcel.weight > 0){
                    if( checkDimension.data ){
                        checkDimension.data.weight = this.isTracking.parcel.weight
                    }else{
                        checkDimension.data = {
                            weight: this.isTracking.parcel.weight
                        }
                    }
                    setLocalStorage.dimension().set( keyStorage , checkDimension.data );
                    this.isTracking.favoriteWeight = true;   
                }
            }
        },
        getDimensionLocalStorage(){
            let key = `${this.courierCode}_${this.shopId}`;
            let checkDimension = setLocalStorage.dimension().get( key );
            return ( checkDimension[key] ) ? {
                status: true, data: checkDimension[key]  
            } : {status: false}
        },
    },
    computed:{
        favoriteWeight(){
            return ['shippop', 'quickexpress'].includes(this.$THEME.name) && this.isTracking.favoriteWeight
        },
    }
}

</script>